module.exports = __webpack_public_path__ + "img/diagnostico-socio.9f2bca54.svg";